var auto = {};
export {
  auto as __exports
};
//# sourceMappingURL=index223.js.map
